import { MenuItem } from "../../Types/Layout/SidebarType";

export const MenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "home",
        type: "link",
        lanClass: "lan-3",
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
      },
      {
        title: "Master",
        id: 2,
        icon: "task",
        type: "sub",
        lanClass: "lan-6",
        active: false,
        children: [
          // { path: `${process.env.PUBLIC_URL}/ticket/create_new`, title: "Add New Plan", type: "link" },
          { path: `${process.env.PUBLIC_URL}/ticket/ticket_plan_list`, title: "Plan List", type: "link" },
          { path: `${process.env.PUBLIC_URL}/ticket/create_ticket_offer`, title: "Add Ticket Offer", type: "link" },
          { path: `${process.env.PUBLIC_URL}/ticket/all_ticket_offer`, title: "All Ticket Offer", type: "link" },
          // { path: `${process.env.PUBLIC_URL}/offer/create_new`, title: "Add New Offer", type: "link" },
          // { path: `${process.env.PUBLIC_URL}/offer/offer_list`, title: "Offer List", type: "link" },
          { path: `${process.env.PUBLIC_URL}/coupon/create_new`, title: "Add New Coupon", type: "link" },
          { path: `${process.env.PUBLIC_URL}/coupon/coupon_list`, title: "Coupon List", type: "link" },
          // { path: `${process.env.PUBLIC_URL}/rfidCard/create_new`, title: "Add New RFID Card", type: "link" },
          // { path: `${process.env.PUBLIC_URL}/rfidCard/rfidCardList`, title: "RFID Card List", type: "link" },
          { path: `${process.env.PUBLIC_URL}/cloth/create_new`, title: "Add New Cloth", type: "link" },
          { path: `${process.env.PUBLIC_URL}/cloth/clothList`, title: "All Cloth", type: "link" },
          { path: `${process.env.PUBLIC_URL}/locker/create_new`, title: "Add New Locker", type: "link" },
          { path: `${process.env.PUBLIC_URL}/locker/lockerList`, title: "All Locker", type: "link" },
          // { path: `${process.env.PUBLIC_URL}/recharge/create_new`, title: "Add New Recharge", type: "link" },
          // { path: `${process.env.PUBLIC_URL}/recharge/rechargeList`, title: "Recharge List", type: "link" },
        ],
      },
    ],
  },
  {
    title: "Applications",
    lanClass: "lan-8",
    Items: [
      {
        title: "Ticket Booking",
        id: 3,
        icon: "project",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/ticket/book_ticket`, type: "link", title: "Book Ticket" },
          { path: `${process.env.PUBLIC_URL}/ticket/booking_history`, type: "link", title: "Booking History" },
          { path: `${process.env.PUBLIC_URL}/ticket/booking_cancelled`, type: "link", title: "All Cancelled Booking" },
          // { path: `${process.env.PUBLIC_URL}/card/card_assign`, type: "link", title: "Card Assign" },
          // { path: `${process.env.PUBLIC_URL}/card/all_card_assign`, type: "link", title: "All Card Assign List" },
          { path: `${process.env.PUBLIC_URL}/cloth/cloth_assign`, type: "link", title: "Cloth Assign" },
          { path: `${process.env.PUBLIC_URL}/cloth/all_cloth_assign`, type: "link", title: "All Cloth Assign" },
          { path: `${process.env.PUBLIC_URL}/locker/locker_assign`, type: "link", title: "Locker Assign" },
          { path: `${process.env.PUBLIC_URL}/locker/all_locker_assign`, type: "link", title: "All Locker Assign" },
        ],
      },
      // {
      //   title: "Recharge",
      //   id: 3,
      //   icon: "project",
      //   type: "sub",
      //   active: false,
      //   children: [
      //     { path: `${process.env.PUBLIC_URL}/recharge/card_recharge`, type: "link", title: "Card Recharge" },
      //     { path: `${process.env.PUBLIC_URL}/recharge/recharge_history`, type: "link", title: "Recharge History" },
      //   ],
      // },
      {
        title: "Food",
        id: 6,
        icon: "ecommerce",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/food/add_category`, title: "Add Category", type: "link" },
          { path: `${process.env.PUBLIC_URL}/food/categoryList`, title: "All Category", type: "link" },
          { path: `${process.env.PUBLIC_URL}/food/add_food`, title: "Add Food", type: "link" },
          { path: `${process.env.PUBLIC_URL}/food/foodList`, title: "All Food", type: "link" },
          { path: `${process.env.PUBLIC_URL}/food/food_order`, type: "link", title: "Food Order" },
          { path: `${process.env.PUBLIC_URL}/food/all_food_order`, type: "link", title: "All Food Order" },
        ],
      },
      {
        title: "Report",
        id: 4,
        icon: "project",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/report/booking-report`, type: "link", title: "Booking Report" },
          { path: `${process.env.PUBLIC_URL}/report/gst-report`, type: "link", title: "GST Report" },
          { path: `${process.env.PUBLIC_URL}/report/food-report`, type: "link", title: "Food Report" },
          { path: `${process.env.PUBLIC_URL}/report/locker-report`, type: "link", title: "Locker Report" },
          { path: `${process.env.PUBLIC_URL}/report/cloth-report`, type: "link", title: "Cloth Report" },
          { path: `${process.env.PUBLIC_URL}/report/refund-report`, type: "link", title: "Refund Report" },
          { path: `${process.env.PUBLIC_URL}/report/refund-list`, type: "link", title: "Refund List" },
        ],
      },
      {
        title: "Staff Management",
        icon: "user",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/staffs/new_staff_add`, type: "link", title: "Add New Staff" },
          // { path: `${process.env.PUBLIC_URL}/users/user_edit`, type: "link", title: "User Edit" },
          { path: `${process.env.PUBLIC_URL}/staffs/all-staffs`, type: "link", title: "All Staffs" },
        ],
      },
      // { path: `${process.env.PUBLIC_URL}/email/letter_box`, icon: "email", title: "Letter Box", type: "link", id: 7 },
      // { path: `${process.env.PUBLIC_URL}/app/task`, icon: "task", type: "link", title: "Task" },
    ],
  },
  // {
  //   title: "Forms & Table",
  //   Items: [
  //     {
  //       title: "Forms",
  //       id: 17,
  //       icon: "form",
  //       type: "sub",
  //       active: false,
  //       children: [
  //         {
  //           title: "Form Controls",
  //           type: "sub",
  //           children: [
  //             { title: "Form Validation", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_controls/form_validation`, bookmark: true },
  //             { title: "Base Inputs", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_controls/base_input` },
  //             { title: "Checkbox & Radio", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_controls/radio_checkbox` },
  //             { title: "Input Groups", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_groups` },
  //             { title: "Input Mask", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_mask` },
  //             { title: "Mega Option", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_controls/mega_option` },
  //           ],
  //         },
  //         {
  //           title: "Form Widget",
  //           type: "sub",
  //           children: [
  //             { title: "Datepicker", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_widget/datepicker` },
  //             { title: "Touchspin", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_widget/touchspin` },
  //             { title: "Switch", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_widget/switch` },
  //             { title: "Typeahead", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_widget/typeahead` },
  //             { title: "Clipboard", type: "link", path: `${process.env.PUBLIC_URL}/forms/forms_widget/clipboard` },
  //           ],
  //         },
  //         {
  //           title: "Form Layout",
  //           type: "sub",
  //           children: [
  //             { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_1`, title: "Form Wizard 1", type: "link" },
  //             { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_2`, title: "Form Wizard 2", type: "link" },
  //             { path: `${process.env.PUBLIC_URL}/forms/forms_layout/two_factor`, title: "Two factor", type: "link" },
  //           ],
  //         },
  //       ],
  //     },

  //     {
  //       title: "Table",
  //       icon: "table",
  //       id: 18,
  //       type: "sub",
  //       children: [
  //         {
  //           title: "Bootstrap Tables",
  //           type: "sub",
  //           children: [
  //             {
  //               title: "Basic Tables",
  //               type: "link",
  //               path: `${process.env.PUBLIC_URL}/table/reactstrap_table/basic_table`,
  //             },
  //             {
  //               title: "Table Components",
  //               type: "link",
  //               path: `${process.env.PUBLIC_URL}/table/reactstrap_table/table_component`,
  //             },
  //           ],
  //         },
  //         {
  //           title: "Data Tables",
  //           type: "sub",
  //           children: [
  //             { path: `${process.env.PUBLIC_URL}/table/data_table/basic_init`, title: "Basic Init", type: "link" },
  //             { path: `${process.env.PUBLIC_URL}/table/data_table/advance_init`, title: "Advance Init", type: "link" },
  //             { path: `${process.env.PUBLIC_URL}/table/data_table/api`, title: "API", type: "link" },
  //             { path: `${process.env.PUBLIC_URL}/table/data_table/data_sources`, title: "Data Source", type: "link" },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   title: "Components",
  //   Items: [
  //     {
  //       title: "Charts",
  //       icon: "charts",
  //       type: "sub",
  //       id: 23,
  //       active: false,
  //       children: [
  //         { path: `${process.env.PUBLIC_URL}/charts/apex_chart`, type: "link", title: "Apex Chart" },
  //         { path: `${process.env.PUBLIC_URL}/charts/google_chart`, type: "link", title: "Google Chart" },
  //         { path: `${process.env.PUBLIC_URL}/charts/chartjs_chart`, type: "link", title: "Chartjs Chart" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "Pages",
  //   Items: [
  //     {
  //       icon: "sample-page",
  //       id: 24,
  //       active: false,
  //       path: `${process.env.PUBLIC_URL}/pages/sample_page`,
  //       title: "Sample Page",
  //       type: "link",
  //     },
  //     {
  //       title: "Others",
  //       icon: "others",
  //       id: 25,
  //       type: "sub",
  //       children: [
  //         {
  //           title: "Authentication",
  //           type: "sub",
  //           children: [
  //             { title: "Login with sweetalert", type: "link", path: `${process.env.PUBLIC_URL}/authentication/login_sweetalert` },
  //             { title: "Register Wizard", type: "link", path: `${process.env.PUBLIC_URL}/authentication/register_wizard` },
  //             { title: "Forget Password", type: "link", path: `${process.env.PUBLIC_URL}/authentication/forget_password` },
  //             { title: "Reset Password", type: "link", path: `${process.env.PUBLIC_URL}/authentication/reset_password` },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   title: "Miscellaneous",
  //   Items: [
  //     {
  //       title: "Blog",
  //       icon: "blog",
  //       id: 27,
  //       type: "sub",
  //       active: false,
  //       children: [
  //         { path: `${process.env.PUBLIC_URL}/blog/blog_details`, title: "Blog Details", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/blog/blog_single`, title: "Blog Single", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/blog/add_post`, title: "Add Post", type: "link" },
  //       ],
  //     },
  //     { id: 33, path: `${process.env.PUBLIC_URL}/support_ticket/support_ticket`, icon: "support-tickets", type: "link", active: false, title: "SupportTicket" },
  //   ],
  // },
];
